<div class="col-12 p-0 addStudentPopup">
    <div class="sectionHeader">
        <h4 class="sectionHeading text-shadow">Grievance Details</h4>
    </div>
    <div class="grievancesItem mat-elevation-z8">
        <div class="grievancesHeader">
          <h5 class="grievancesSubject">{{replyData?.subject}}</h5>
        </div>
        <div class="grievancesBody">
          <label class="grievancesID"><span class="grievancesLabelHeading">ID: </span>{{replyData?.grievance_id}}</label>
          <label class="grievancesDate"><span class="grievancesLabelHeading">Created Date: </span>{{replyData?.created_at | date: 'dd/MM/yyyy'}}</label>
          <label class="grievancesNature">{{replyData?.nature}}</label>
        </div>

        <label class="grievancesMsgHeading">Message: </label>
        <div class="messageMainContainer">
            <div class="messageContainer">
                <p class="grievancesMsgText">{{replyData?.body}}</p>
            </div>
            <div class="attachmentContainer" *ngIf="attachmentFlag">
               <!-- <div *ngIf="extension=='pdf'; else imageBlock"> -->
                    <a style="font-size: x-small; margin: 5px;" href="{{baseUrl}}/Grievances/{{grievanceAttchPath}}" class="btn btn-primary" target="_blank" >
                        View Attachment
                    </a>
                    <!-- <embed [src]=testUrl width="100%" height="100%" />
                    <object data="{{testUrl}}" type="application/pdf" style="border-radius: 4px;"></object>
                    <iframe src="https://qa-slaapi.aicte-india.org/files/expert_bank_mandate_forms/Expert_Bank_Mandate_11.pdf" type="application/pdf" style="border-radius: 4px;" height="110px" frameborder="0"></iframe>
                    <object data="https://qa-slaapi.aicte-india.org/files/expert_bank_mandate_forms/Expert_Bank_Mandate_11.pdf" type="application/pdf" style="border-radius: 4px;"></object>
                    <iframe [src]="photoURL(testUrl)" type="application/pdf" style="border-radius: 4px;" height="110px" frameborder="0"></iframe> -->
                    <!-- <object [data]="photoURL()" type="application/pdf" style="border-radius: 4px;"></object> -->
                <!-- </div>
                <ng-template #imageBlock>
                    <a style="font-size: x-small; margin: 5px; color: white;" (click)="viewImg(grievanceAttchPath)" class="btn btn-primary" >
                        View Attachment
                    </a>
                </ng-template> -->
            </div>
        </div>

        <div *ngIf="replyFlag">
            <label class="grievancesMsgHeading">Reply: </label>
            <div class="messageMainContainer">
                <div class="messageContainer">
                    <p class="grievancesMsgText">{{replyData?.reply}}</p>
                </div>
                <div class="attachmentContainer" *ngIf="replyAttachmentFlag">
                    <!-- <div *ngIf="replyExtension=='pdf'; else replyImageBlock"> -->
                        <a style="font-size: x-small; margin: 5px;" href="{{baseUrl}}/Grievances_reply/{{grievanceReplyAttchPath}}" class="btn btn-primary" target="_blank" >
                            View Attachment
                        </a>
                    <!-- </div>
                    <ng-template #replyImageBlock>
                        <a style="font-size: x-small; margin: 5px; color: white;" (click)="viewReplyImg(grievanceReplyAttchPath)" class="btn btn-primary" >
                            View Attachment
                        </a> -->
                        <!-- <img style="border-radius: 4px;" height="110px" (click)="viewReplyImg(grievanceReplyAttchPath)" [src]='grievanceReplyImg' alt="Grievance_Reply_image"> -->
                    <!-- </ng-template> -->
                </div>
            </div>      
        </div>

        <div class="stepContainer">
        <div class="step done" data-desc="Ticket Raised"><span>1</span><i class="fa fa-check" aria-hidden="true"></i></div>
        <div *ngIf="replyData.status_id == 1" class="step active" data-desc="In Progress"><span>2</span><i class="fa fa-check" aria-hidden="true"></i></div>
        <div *ngIf="replyData.status_id == 2" class="step done" data-desc="Ticket Resolved"><span>3</span><i class="fa fa-check" aria-hidden="true"></i></div>
        <div class="step done" [ngClass]="{'done': replyData.status_id==2}" data-desc="Ticket Resolved"><span>3</span><i class="fa fa-check" aria-hidden="true"></i></div>
        </div>
    </div>
</div>



<!-- <div class="col-12 p-0 addStudentPopup">
    <mat-card class="p-0">

        <mat-card-header class="card-header matHeader">
            <h5 style="color: black; margin-right: 375px;">Grievance Details</h5>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close disableRipple>
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>
        <div class="EventContent">
            <p class="EventTitle"><strong style="color:#073764;">Query:</strong> {{replyData?.body}}</p>
            <p class="EventTitle" *ngIf="attachmentFlag"><strong style="color:#073764;">Attachment:</strong><img style="padding-left: 10px; margin-top: 6px; border-radius: 3%;" height="100px"
                (click)="viewImg(grievanceAttchPath)" [src]='grievanceImg' alt="Grievance_image"></p>
            <hr>
            <p class="EventbodyText" *ngIf="replyFlag; else noReply"><strong>Reply:</strong> {{replyData?.reply}}</p>
            <p class="EventbodyText" *ngIf="replyAttachmentFlag"><strong>Attachment:</strong><img style="padding-left: 10px; margin-top: 6px; border-radius: 3%;" height="100px"
                (click)="viewReplyImg(grievanceReplyAttchPath)"  [src]='grievanceReplyImg' alt=""></p>

            <ng-template #noReply>
                <p class="EventbodyText"><strong>Reply:</strong> (In Progess)</p>
            </ng-template>
        </div>
    </mat-card>
</div> -->
